import { api } from "./api";
import { callAuthApi } from "../helpers/";

const callApiSaqsCreate = async (data) => {
  //console.log(11);
  if (callAuthApi()) {
    //console.log(22);

    return await api.service("api/saqs").create(data);
  } else {
    //console.log(33);
    return null;
  }
};

const callApiSaqsPatch = async (saqId, data) => {
  if (callAuthApi()) {
    return await api.service("api/saqs").patch(saqId, data);
  } else {
    return null;
  }
};

const callApiSaqsGet = async (saqId) => {
  if (callAuthApi()) {
    return await api.service("api/saqs").get(saqId);
  } else {
    return null;
  }
};

const callApiSaqsFind = async (data) => {
  if (callAuthApi()) {
    console.log("0. callApiSaqsFind data", data);
    if (data && data.subdomain) {
      console.log("1. callApiSaqsFind", data);
      return await api
        .service("api/saqs")
        .find({ query: { subdomain: data.subdomain } });
    } else if (data && data.userId) {
      return await api
        .service("api/saqs")
        .find({ query: { userId: data.userId } });
    } else {
      console.log("2. callApiSaqsFind", data);
      return await api.service("api/saqs").find({});
    }
  } else {
    return null;
  }
};

const callApiSaqsDelete = async (saqId) => {
  if (callAuthApi()) {
    console.log("callApiSaqsDelete");
    return await api.service("api/saqs").remove(saqId);
  } else {
    return null;
  }
};

const callApiDownloadSaqPdf = async (data) => {
  if (callAuthApi()) {
    return await api.service("api/generate-saq-pdf").create({ query: data });
  } else {
    return null;
  }
};

export {
  callApiSaqsFind,
  callApiSaqsGet,
  callApiSaqsCreate,
  callApiSaqsPatch,
  callApiSaqsDelete,
  callApiDownloadSaqPdf,
};
